import { faListUl, faScreenUsers, faSearch, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, ModalClose, ModalContent, ModalHeading } from '@pickleballinc/react-ui';

interface SubsListSelectModalProps {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	onSelect: (list: 'team' | 'event' | 'users') => void;
	useScheduleGroups: boolean;
}

export default function SubsListSelectModal({ isOpen, setIsOpen, onSelect, useScheduleGroups }: SubsListSelectModalProps) {
	return (
		<Modal open={isOpen} onOpenChange={() => setIsOpen(false)}>
			<ModalContent
				className="flex flex-col justify-center"
				style={{
					width: 560
				}}
			>
				<ModalHeading className="flex flex-col">
					<div className="flex w-full items-center justify-between">
						<div className="flex-1 text-2xl font-semibold leading-8">Select the player from</div>
						<ModalClose className="ml-auto">
							<FontAwesomeIcon icon={faTimes} size="xl" className="text-gray-500" />
						</ModalClose>
					</div>
					<p className="text-sm font-normal text-gray-500">You first need to choose from which list you want to choose your sub player.</p>
				</ModalHeading>
				<div className="mt-6 flex flex-col justify-around gap-4 sm:flex-row">
					<div
						onClick={() => onSelect('team')}
						className="flex w-full cursor-pointer flex-row items-start gap-2 rounded-2xl border-t-4 border-darkorange-700 bg-gray-50 p-3 sm:w-[160px] sm:flex-col"
					>
						<div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
							<FontAwesomeIcon icon={faScreenUsers} size="lg" className="text-darkorange-600" />
						</div>
						<div>
							<h2 className="text-xl font-semibold text-gray-900">Team</h2>
							<p className="text-sm text-gray-600">Players from the team only.</p>
						</div>
					</div>
					{useScheduleGroups && (
						<div
							onClick={() => onSelect('event')}
							className="flex w-full cursor-pointer flex-row items-start gap-2 rounded-2xl border-t-4 border-darkorange-700 bg-gray-50 p-3 sm:w-[160px] sm:flex-col"
						>
							<div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
								<FontAwesomeIcon icon={faListUl} size="lg" className="text-darkorange-600" />
							</div>
							<div>
								<h2 className="text-xl font-semibold text-gray-900">Sub list</h2>
								<p className="text-sm text-gray-600">Players from event sub list.</p>
							</div>
						</div>
					)}
					<div
						onClick={() => onSelect('users')}
						className="flex w-full cursor-pointer flex-row items-start gap-2 rounded-2xl border-t-4 border-darkorange-700 bg-gray-50 p-3 sm:w-[160px] sm:flex-col"
					>
						<div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
							<FontAwesomeIcon icon={faSearch} size="lg" className="text-darkorange-600" />
						</div>
						<div>
							<h2 className="text-xl font-semibold text-gray-900">All players</h2>
							<p className="text-sm text-gray-600">All the players in the system.</p>
						</div>
					</div>
				</div>
			</ModalContent>
		</Modal>
	);
}
